import { inject, Injectable } from '@angular/core';
import {
  BasicDialogService,
  DialogPresets,
} from '@principle-theorem/ng-shared';
import {
  type IPatient,
  isPatient,
} from '@principle-theorem/principle-core/interfaces';
import { type WithRef, isWithRef, snapshot } from '@principle-theorem/shared';
import { ManagementResource } from '../models/management-resource';
import {
  type IManagementTool,
  type IToolRunContext,
} from '../models/management-tool';
import {
  type IPatientDetailsHistoryDialogData,
  PatientDetailsHistoryDialogComponent,
} from '../patient-details-history-dialog/patient-details-history-dialog.component';

function isPatientWithRef(value: unknown): value is WithRef<IPatient> {
  return isPatient(value) && isWithRef<IPatient>(value);
}

@Injectable({ providedIn: 'root' })
export class PatientDetailsHistoryTool implements IManagementTool {
  private _dialog = inject(BasicDialogService);

  readonly name = 'patient-details-history';
  readonly label = 'Patient Details History';
  readonly icon = 'history';
  readonly description = 'View the history of patient detail changes';
  readonly resource = ManagementResource.Patient;

  async run(context: IToolRunContext): Promise<void> {
    if (!context.resource) {
      return;
    }
    const value = await snapshot(context.resource.value$);
    if (!value || !isPatientWithRef(value)) {
      return;
    }
    const data: IPatientDetailsHistoryDialogData = { patient: value };
    this._dialog.open(
      PatientDetailsHistoryDialogComponent,
      DialogPresets.extraLarge({ data })
    );
  }
}
